import React from 'react'
import { useEventLogging } from '@packages/jslib'

import ChangeQPPButton from '@components/Button/ChangeQuestionPerPageButton/ChangeQPPButton'

type ChangeQPPButtonLayoutProps = {
  changeQuestionPerPage: (num: number) => void
  currentQuestionPerPage: number
}

const ChangeQPPButtonLayout: React.FC<ChangeQPPButtonLayoutProps> = ({
  changeQuestionPerPage,
  currentQuestionPerPage,
}) => {
  // Todo 디자인 확정되면 반영 필요.
  const { trackButtonClick } = useEventLogging()
  const changeSingleQuestionViewButtonProps = {
    buttonHandler: () => {
      trackButtonClick({
        name: 'Screen Layout',
        properties: {
          layout: 1,
        },
      })
      changeQuestionPerPage(1)
    },
    theNumberOfQuestionToChange: 1,
    isSelected: currentQuestionPerPage === 1,
  }
  const changeDoubleQuestionViewButtonProps = {
    buttonHandler: () => {
      trackButtonClick({
        name: 'Screen Layout',
        properties: {
          layout: 2,
        },
      })
      changeQuestionPerPage(2)
    },
    theNumberOfQuestionToChange: 2,
    isSelected: currentQuestionPerPage === 2,
  }
  return (
    <div className={'flex font-medium'}>
      <span className={'text-base w-[30px] flex items-center font-normal mb-0.5 mx-1'}>
        화면 <br />
        배치
      </span>
      <div className={'flex flex-col mx-2'}>
        <ChangeQPPButton {...changeSingleQuestionViewButtonProps} />
        <span className={'text-xs'}>1단 보기</span>
      </div>
      <div className={'flex flex-col mx-2'}>
        <ChangeQPPButton {...changeDoubleQuestionViewButtonProps} />
        <span className={'text-xs'}>2단 보기</span>
      </div>
    </div>
  )
}

export default ChangeQPPButtonLayout
